import { render, staticRenderFns } from "./UpsellPackages.vue?vue&type=template&id=7dfac8e0"
import script from "./UpsellPackages.vue?vue&type=script&lang=js"
export * from "./UpsellPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports